<div mat-dialog-content>
  <div class="success-message">
    <div class="success-checkmark">
        <div class="check-icon">
          <span class="icon-line line-tip"></span>
          <span class="icon-line line-long"></span>
          <div class="icon-circle"></div>
          <div class="icon-fix"></div>
        </div>
      </div>
      <div class="success">Vous serez contacté dans les plus brefs délais.</div>
</div>